<div class="payment-success-container">
  <div class="payment-card" [class.not-loading]="!isLoading">
    <div class="circle-icon">
        <img src="assets/images/cancel.gif" alt="pending">
    </div>
    <h2>Payment Failed!</h2>
    <p>
      Hey, seems like there was some issue. Please try again or update your
      payment method.
    </p>
    <h3>Total Payment</h3>
    <h1>${{paymentData?.amount || 'NA'}}</h1>
    <div class="payment-details">
      <div class="detail">
        <p>Ref Number</p>
        <h4>{{paymentData?.customerId || 'NA'}}</h4>
      </div>
      <div class="detail">
        <p>Payment Time</p>
        <h4>{{ paymentData ? convertToLocalTime() : '' }}</h4>
      </div>
      <div class="detail">
        <p>Payment Method</p>
        <h4>{{paymentData?.paymentMethod}}</h4>
      </div>
      <div class="detail">
        <p>Sender Name</p>
        <h4>{{paymentData?.senderName || 'NA'}}</h4>
      </div>
    </div>

    <div class="payment-try-btn">
      <app-button (click)="tryPaymentAgain()" text="Try Again"></app-button>
    </div>
  </div>
  <div class="payment-btn">
    <app-button text="Back" class="h-100" (onClick)="back()" ></app-button>
  </div>
</div>
